import Interpolate, { SYNTAX_I18NEXT } from '@doist/react-interpolate'

import { TFunction } from 'next-i18next'

export type CustomInterpolateProps = {
    t: TFunction
    i18nKey: string
    mapping?: Record<string | number, React.ReactNode>
}

export default function CustomInterpolate({ t, i18nKey, ...props }: CustomInterpolateProps) {
    return (
        <Interpolate
            string={t(i18nKey, { skipInterpolation: true })}
            syntax={SYNTAX_I18NEXT}
            {...props}
        />
    )
}
